import { createSlice } from '@reduxjs/toolkit';
// utils
import { OnboardingState } from 'src/@types/onboarding';

// ----------------------------------------------------------------------

const initialState: OnboardingState = {
  isLoading: false,
  error: null,
  activeStep: 0,
};

const slice = createSlice({
  name: 'onboarding',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    resetOnboarding(state) {
      state.activeStep = 0;
    },

    setActiveStep(state, action) {
      state.activeStep = action.payload;
    },

    onPrevStep(state) {
      state.activeStep -= 1;
    },

    onNextStep(state) {
      state.activeStep += 1;
    },

    onGotoStep(state, action) {
      const goToStep = action.payload;
      state.activeStep = goToStep;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { resetOnboarding, setActiveStep, onGotoStep, onPrevStep, onNextStep } = slice.actions;
